// hooks/useSessionExpirationCheck.ts
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearToken } from "../store/slices/authSlice";

export function useSessionExpirationCheck(
  sessionExpiration: string | null,
  token: string | null
) {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!token) {

      if (window.location.pathname === "/") {
        return
      }

      navigate("/area-do-cliente");
      return;
    }

    intervalRef.current = setInterval(() => {
      if (sessionExpiration) {
        const expiration = new Date(sessionExpiration);
        const now = new Date();

        if (now >= expiration) {
          console.clear();
          console.warn("Sessão expirada, redirecionando para a tela de login...");
          dispatch(clearToken());
          localStorage.removeItem("_user");
          localStorage.removeItem("SESSION_EXPIRATION");
          clearInterval(intervalRef.current!);
          intervalRef.current = null;
          navigate("/area-do-cliente");
        }
      }
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [sessionExpiration, token, navigate, dispatch]);
}
